((Drupal, once) => {
  Drupal.behaviors.variable = {
    attach: (context, settings) => {
      Drupal.getVariable = (
        name,
        defaultValue = '',
        element = document.querySelector(':root'),
      ) => {
        const style = window.getComputedStyle(element);
        let value = style.getPropertyValue(`--${name}`);

        // If the value is a rem value, convert it to pixels.
        if (value.includes('rem')) {
          value = value.replace('rem', '');
          value *= parseFloat(
            getComputedStyle(document.documentElement).fontSize,
          );
        }
        return value && value !== '' ? value : defaultValue;
      };
    },
  };
})(Drupal, once);
